import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { HelperService } from 'src/app/core/services/helper.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { ResizeEvent } from 'angular-resizable-element';
import { JsonEditorOptions } from 'ang-jsoneditor';
import { SearchService } from 'src/app/core/services/search.service';

@Component({
  selector: 'app-postman-console',
  templateUrl: './postman-console.component.html',
  styleUrls: ['./postman-console.component.scss'],
})
export class PostmanConsoleComponent implements OnInit {
  @Input() postmanPreviewData: object;

  consoleLogItems: any[] = [];
  detailedLogItems: any[] = [];
  visibleIndex = -1
  copyPreviewData: any;
  copyStr: string = 'copy';
  editorOptions:JsonEditorOptions;
  status:any;
  containerStyle:object={}
  response_time:any;
  loader=false;
  consoleNoteMsg:Boolean = false;
  isLeftArrowVisible:Boolean = true;
  constructor(
    private bottomSheetRef: MatBottomSheetRef<PostmanConsoleComponent>,
    public helperService: HelperService,
    public clipboard : Clipboard,
    private searchService:SearchService,
  ) { }

  ngOnInit() {
    this.searchService.loading$.subscribe(isLoading => {
      this.loader = isLoading;
    });

    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.mainMenuBar = false;
    this.editorOptions.navigationBar = false;
    this.editorOptions.mode = 'view';
    this.editorOptions.expandAll = false;

    this.helperService.getConsoleData().subscribe((data) => {
      if (!this.helperService.isConsoleClear) {
        this.consoleLogItems = [];
        this.detailedLogItems = [];
        for (let item of data) {
          const parsedDataList = {};
          const parser = new DOMParser();
          let rawData = item.data;

          if (rawData.includes("&quot;")) {
            rawData = rawData.replaceAll("&quot;", '"')
                             .replaceAll("&lt;", '<')
                             .replaceAll("&gt;", '>');
          }

          const doc = parser.parseFromString(rawData, 'text/html');
          let index = 1;
          doc.querySelectorAll('pre').forEach((element: HTMLElement) => {
            let jsonData = JSON.parse(element.textContent || '{}');
            
            if (element.innerHTML.includes('<!--?xml')) {
              Object.keys(jsonData).forEach((key) => {
                if (typeof jsonData[key] === 'string' && jsonData[key].includes('\n\n\t')) {
                  jsonData[key] = this.helperService.extractXml(element.innerHTML);
                }
              });
            }

            parsedDataList[index] = jsonData;
            index++;
          });

          this.consoleLogItems.push({
            data : parsedDataList
          })

          this.detailedLogItems.push({
            data: parsedDataList, 
            operationName:item.operationName,
            response_time:item.response_time,
            status: item.status
          });
        }
      }

      this.containerStyle = {
        position: 'fixed',
        width: `100%`,
        height: `100%`,
      };
    });
  }
  cancelconsole(){
    this.searchService.setLoading(false);
    this.loader=false;
  }

  isDataSource(operationName: string): boolean {
    const dataSources = [
      'API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)',
      'Database',
      'Websocket',
      'Bizintel360 Data Lake',
      'Email'
    ];
    return dataSources.includes(operationName);
  }

  getKeys(object){
    return Object.keys(object);
  }
  
  processHtmlString(htmlString: string): string {
    if (this.containsError(htmlString)) {
      return `<span style="color:red">${this.escapeHtml(htmlString)}</span>`;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    doc.querySelectorAll('pre').forEach((preTag) => {
      const jsonString = preTag.textContent || '';
      try {
        const jsonObject = JSON.parse(jsonString);
        const highlightedJson = this.syntaxHighlight(jsonObject);
        preTag.innerHTML = highlightedJson;
      } catch (error) {
        console.error('Error parsing JSON:', error);
        preTag.innerHTML = `<span style="color:red">${jsonString}</span>`;
      }
      
      const hr = document.createElement('hr');
      hr.style.backgroundColor = '#ccc';
      preTag.parentNode?.insertBefore(hr, preTag.nextSibling);
    });
    return doc.body.innerHTML;
  }

  syntaxHighlight(json: any): string {
    return JSON.stringify(json, null, 2)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
        let color = 'black';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            color = 'blue';
          } else {
            color = 'black';
          }
        } else if (/true|false/.test(match)) {
          color = 'blue';
        }
        return `<span style="color:${color}">${match}</span>`;
      });
  }

  containsError(htmlString: string): boolean {
    try {
        const jsonObject = JSON.parse(htmlString);
        return jsonObject && jsonObject.hasOwnProperty('error');
    } catch (error) {
        return false;
    }
  }

  escapeHtml(unsafe: string): string {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
  }

  openLink(): void {
    this.bottomSheetRef.dismiss();
  }

  showSubItem(ind) {
    if (document.getElementsByClassName('jsoneditor-readonly').length>0) {
      
      let keys = document.getElementsByClassName('jsoneditor-readonly');
      for (let key of keys) {
        if(key.innerHTML == 'array') {
          key.innerHTML = "";
        } 
      }
    }  

    if (this.visibleIndex === ind) {
      this.visibleIndex = -1;
    } else {
      this.visibleIndex = ind;
    }
  }

  copyResponse(responseData?) {
    // let copying_data = JSON.stringify(responseData, null, 2);
    let res=''
    for(let key of Object.keys(responseData)){
      res+=JSON.stringify(responseData[key],null,2)
      res+='\n'
    }
    res=res.replace(/\\"/g, '');
    navigator.clipboard.writeText(res).then(() => {
      this.copyStr = 'Copied';
      setTimeout(() => {
        this.copyStr = 'Copy';
      }, 2000);
    }).catch(err => {
      console.error('Error copying:', err);
    });
  }

  validate(event: ResizeEvent): boolean {
    if (event.rectangle.height < 230) return false;
    else return true;
  }
  
  onResizing(e: ResizeEvent) {
    let elements=document.getElementsByTagName('mat-bottom-sheet-container');
    for(let i = 0; i < elements.length; i++){
      const element = elements[i] as HTMLElement;
      element.style.height = `${e.rectangle.height}px`;
    }
    this.containerStyle = {
      position: 'fixed',
      width: `100%`,
      height: `${e.rectangle.height}px`,
    };
  }

  clearLogs() {
    this.consoleLogItems = [];
    this.detailedLogItems = [];
    this.helperService.isConsoleClear = true;
  }

  changeErrorColor(){
    if (document.getElementsByClassName('jsoneditor-field').length>0) {
      
      let keys = document.getElementsByClassName('jsoneditor-field');
      for (let key of keys) {
        if (key.textContent.includes('error')) {
          key.setAttribute('key', 'error message');
          if (key.parentElement.nextElementSibling.nextElementSibling) {
            key.parentElement.nextElementSibling.nextElementSibling.children[0].setAttribute(
              'key',
              'error message'
            );
          }
        }
      }
    }
  }

  toggleConsoleNoteMsg(){
    this.consoleNoteMsg = !this.consoleNoteMsg;
    this.isLeftArrowVisible = !this.isLeftArrowVisible;
  };

}
